var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 422,
    height: 93,
    viewBox: "0 0 422 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.745 45.8401L15.005 22.0401C14.755 21.6201 14.145 21.6201 13.905 22.0401L0.165 45.8401C-0.055 46.2201 -0.055 46.6801 0.165 47.0501L13.905 70.8501C14.155 71.2701 14.765 71.2701 15.005 70.8501L28.745 47.0501C28.965 46.6801 28.965 46.2201 28.745 45.8401Z",
    fill: "url(#paint0_linear_395_1107)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M106.715 45.84L80.6048 0.610001C80.3848 0.230001 79.9848 0 79.5548 0H27.3248C26.8948 0 26.4848 0.230001 26.2748 0.610001L21.9448 8.11L43.7248 45.84C43.9448 46.22 43.9448 46.68 43.7248 47.05L21.9448 84.78L26.2748 92.28C26.4948 92.66 26.8948 92.89 27.3248 92.89H79.5548C79.9848 92.89 80.3948 92.66 80.6048 92.28L106.715 47.06C106.935 46.68 106.935 46.22 106.715 45.84ZM91.7348 47.06L73.1148 79.32C72.8948 79.7 72.4948 79.93 72.0648 79.93H41.9448C41.0048 79.93 40.4248 78.92 40.8948 78.11L58.8048 47.06C59.0248 46.68 59.0248 46.22 58.8048 45.85L40.8848 14.81C40.4148 14 41.0048 12.99 41.9348 12.99H72.0548C72.4848 12.99 72.8948 13.22 73.1048 13.6L91.7248 45.86C91.9548 46.22 91.9548 46.68 91.7348 47.06Z",
    fill: "url(#paint1_linear_395_1107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M195.855 50.5001C195.855 68.3101 183.955 76.6801 170.415 76.6801H132.415V35.0101C132.415 29.1001 137.205 24.3101 143.115 24.3101H170.425C183.955 24.3201 195.855 32.7001 195.855 50.5001ZM182.385 50.5001C182.385 37.7801 175.505 35.6101 165.325 35.6101H145.875V65.3801H165.325C175.505 65.3901 182.385 63.2201 182.385 50.5001Z",
    fill: "#F5F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M214.175 35.0101V45.6301H256.065V55.3601H214.175V65.9801H256.065V76.6801H200.705V35.0101C200.705 29.1001 205.495 24.3101 211.405 24.3101H256.065V35.0101H214.175Z",
    fill: "#F5F5F5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M288.755 50.4998L259.275 24.3198H275.745C277.085 24.3198 278.375 24.8098 279.375 25.7098L297.875 42.2798L316.295 25.7198C317.295 24.8198 318.585 24.3298 319.935 24.3298H336.475L306.995 50.5098L336.475 76.6898H319.935C318.595 76.6898 317.295 76.1898 316.295 75.2998L297.875 58.7398L279.375 75.3098C278.375 76.1998 277.085 76.6998 275.745 76.6998H259.275L288.755 50.4998Z",
    fill: "#F5F5F5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M352.715 76.6801H339.245V35.0101C339.245 29.1001 344.035 24.3101 349.945 24.3101H352.715V76.6801Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M410.175 35.6101H396.035V76.6801H382.565V35.6101H357.125C357.125 29.3701 362.185 24.3101 368.425 24.3101H421.465C421.465 30.5601 416.405 35.6101 410.175 35.6101Z",
    fill: "#F5F5F5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_395_1107",
    x1: 65.5368,
    y1: -23.0893,
    x2: -14.2892,
    y2: 85.5815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00288617,
    stopColor: "#9057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5902,
    stopColor: "#0BAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9766,
    stopColor: "#0BFFFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_395_1107",
    x1: 90.8583,
    y1: -4.4889,
    x2: 11.0322,
    y2: 104.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00288617,
    stopColor: "#9057FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5902,
    stopColor: "#0BAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9766,
    stopColor: "#0BFFFF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1eacd5852a639a3505bda78b7b825e8f.svg";
export { ForwardRef as ReactComponent };